import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { clientMutation, clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";

import { resetALL } from 'Redux/actions';

//STATE INITIAL
const INIT_STATE = {
  error: null,
  loading: false,
  items: [],
  total: 0,
  scanEventsStatus: 0,
  resumeEvents: [],
  unitsIds: [],
  dashboard: []
};

//define routes to logs
const route = "modules/maintenance/views/main/components/emissionCheckTab/redux/slice";

//async action to search values by filters
const emissionCheckSearch = createAsyncThunk('emissionCheck/list/search', async ({ conditions, sort, limit = 10, offset = 0 }, { rejectWithValue, dispatch, getState }) => {
  try {
    const response = await clientQuery(
      emissionCheckSearch.query,
      {
        conditions,
        sort,
        limit,
        offset
      },
      endpoints.GRAPHQL_GENERAL_V2
    );
    return response?.data || { items: [], total: 0 };
  } catch (exc) {
    ExceptionManager(exc, route, 'emissionCheckSearch');
    return rejectWithValue(exc)
  }
});

emissionCheckSearch.query = `
  query searchCarbSchedules($conditions: [CarbScheduleSearchInput], $sort: [CarbScheduleSortInput], $limit: Int, $offset: Int) {
    data: searchCarbSchedules(conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
      items {
        id
        unitId
        lastScanStatus
        lastScanDate
        nextDeadline
        status
        unit {
          id
          label
          esn
        }
        vehicleInformation {
          vin
          licensePlate
        }
      }
      total
    }
  }
`;

export { emissionCheckSearch };

export const emissionCheckScanEvents = createAsyncThunk('emissionCheck/scan', async (params, { rejectWithValue, dispatch, getState }) => {
  try {
    const response = await clientMutation(
      `
       mutation scanEventsCarbSchedule ($id: Int!, $unitId: Int!) {
        data: scanEventsCarbSchedule (id: $id, unitId: $unitId) {
          items {
            scanDate
            scanStatus
            errorMessage
          }
        }
      }
      `,
      {
        id: params.data?.id,
        unitId: params.data?.unitId
      },
      endpoints.GRAPHQL_GENERAL_V2
    );
    return response.data?.items;
  } catch (exc) {
    ExceptionManager(exc, route, 'emissionCheckScanEvents');
    return rejectWithValue(exc)
  }
});

//async action to search values by filters
export const emissionCheckGetCarbUnitsIds = createAsyncThunk('emissionCheck/units', async (params, { rejectWithValue, dispatch, getState }) => {
  try {
    const response = await clientQuery(
      `
      query getCarbUnitsIds {
        data: getCarbUnitsIds {
          items {
            unitId
          }
        }
      }
     `,
      {},
      endpoints.GRAPHQL_GENERAL_V2
    );

    return response?.data;
  } catch (exc) {
    ExceptionManager(exc, route, 'emissionCheckGetCarbUnitsIds');
    return rejectWithValue(exc)
  }
});

//async action to search values by filters
export const emissionCheckGetCarbDashboardData = createAsyncThunk('emissionCheck/dashboard', async (params, { rejectWithValue, dispatch, getState }) => {
  try {
    const response = await clientQuery(
      `
      query getCarbDashboardData {
        data: getCarbDashboardData {
          items {
            label
            total
          }
        }
      }
     `,
      {},
      endpoints.GRAPHQL_GENERAL_V2
    );

    return response?.data;
  } catch (exc) {
    ExceptionManager(exc, route, 'emissionCheckGetCarbDashboardData');
    return rejectWithValue(exc)
  }
});

//reducer object
const maintenanceEmissionCheckRedux = createSlice({
  name: 'emissionCheck/list',
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : INIT_STATE
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //emissionCheckSearch
    builder.addCase(emissionCheckSearch.pending, (state, action) => {
      state.loading = true
    });
    builder.addCase(emissionCheckSearch.fulfilled, (state, action) => {
      state.loading = false;
      state.items = action.payload.items
      state.total = action.payload.total
    });
    builder.addCase(emissionCheckSearch.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload
    });

    //emissionCheckScanEvents
    builder.addCase(emissionCheckScanEvents.pending, (state, action) => {
      state.loading = true
      state.scanEventsStatus = 0
      state.resumeEvents = []
    });
    builder.addCase(emissionCheckScanEvents.fulfilled, (state, action) => {
      state.loading = false;
      state.scanEventsStatus = action.payload?.length ? 1 : 2;
      state.resumeEvents = action.payload
    });
    builder.addCase(emissionCheckScanEvents.rejected, (state, action) => {
      state.loading = false;
      state.scanEventsStatus = 2;
      state.error = action.payload;
    });

    //emissionCheckGetCarbUnitsIds
    builder.addCase(emissionCheckGetCarbUnitsIds.pending, (state, action) => {
      state.unitsIds = []
    });
    builder.addCase(emissionCheckGetCarbUnitsIds.fulfilled, (state, action) => {
      state.unitsIds = action.payload
    });
    builder.addCase(emissionCheckGetCarbUnitsIds.rejected, (state, action) => {
      state.unitsIds = []
    });

    //emissionCheckGetCarbDashboardData
    builder.addCase(emissionCheckGetCarbDashboardData.pending, (state, action) => {
      state.dashboard = []
    });
    builder.addCase(emissionCheckGetCarbDashboardData.fulfilled, (state, action) => {
      state.dashboard = action.payload
    });
    builder.addCase(emissionCheckGetCarbDashboardData.rejected, (state, action) => {
      state.dashboard = []
    });
  },
})

// Extract and export the action creators object and the reducer
export const { actions, reducer } = maintenanceEmissionCheckRedux;

// Extract and export each action creator by name
export const { reset, changeFilters } = actions;

//Simple async action

// Export the reducer, either as a default or named export
export default reducer;